import { Toaster as Sonner, toast ,ToasterProps} from "sonner";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

interface AlertComponentProps {
    position?: ToasterProps["position"];
    variant?: "default" | "success" | "error" | "warning";
}

const variantClasses = {
    default: "bg-background text-foreground border-border",
    success: "bg-green-600 text-white",
    error: "bg-red-600 text-white",
    warning: "bg-yellow-500 text-black",
};

const AlertComponent = ({ position = "top-right", variant = "default" }: AlertComponentProps) => {
    const { theme = "system" } = useTheme();

    return (
        <Sonner
            position={position}
            theme={theme as "light" | "dark" | "system"}
            className={cn("toaster group", variantClasses[variant])}
            toastOptions={{
                classNames: {
                    toast: "group toast group-[.toaster]:shadow-lg",
                    description: "group-[.toast]:text-muted-foreground",
                    actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground font-medium",
                    cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground font-medium",
                },
            }}
        />
    );
};

export default AlertComponent;

const closeToast = () => {
    toast.dismiss();
};

export const AlertCloseButton = () => {
    return (
        <div
            className="toast-close-btn"
            id="toast-close-btn"
            onClick={closeToast}
            onKeyDown={closeToast}
            role="button"
            aria-label="close"
        >
            x
        </div>
    );
};
